<template>
    <div class="trash-alert-main" :class="[alertData.isDarkTheme? 'dark-theme-trash-alert':'']" @click="close" v-if="alertData.show && alertData.type === 'message'">
      <!-- <transition name="opacity">
        <div class="cover"></div>
      </transition> -->
      <transition name="alert">
        <div class="box" @click.stop="stopClick">
          <div class="message-header">
            {{alertData.messageTitle}}
            <!-- <i class="message-close iconfont iconx" @click="close"></i> -->
          </div>
          <div class="message-content" v-if="alertData.inputData && alertData.inputData.show">
            <div class="message-input-main">
              <input :style="{width: alertData.inputData.showLength ? 'calc(100% - 100px)' : 'calc(100% - 40px)'}" type="text" v-model="value" :placeholder="alertData.inputData.placeholder" :maxlength="maxlength">
              <div class="message-input-length" v-if="alertData.inputData.showLength">{{value.length}}/{{maxlength}}</div>
            </div>
          </div>
          <div class="message-content" v-if="alertData.moduleTitles">
<!--            <p class="sub-title">选择模块内容，生成专业简历名称</p>-->
            <div class="select-list flex">
              <div @click="selectLabel(item)" class="select-item" :class="{'is-active': item === value}" v-for="(item, index) in alertData.moduleTitles" :key="index">
                {{ item }}
              </div>
            </div>
          </div>
          <div class="message-content" v-else v-html="alertData.messageContent"></div>
          <div class="message-btn">
            <button :class="['cancel', alertData.cancelButtonClass ||'' ]" @click="cancel" v-if="alertData.showCancelButton">
              <span>{{alertData.cancelButtonText || '取消'}}</span>
            </button>
            <button :class="['action', alertData.confirmButtonClass ||'' ]" v-if="alertData.showConfirmButton" @click="confirm">
              <span>{{alertData.confirmButtonText || '确定'}}</span>
            </button>
          </div>
        </div>
      </transition>
    </div>
</template>
<script>
import {mapState} from 'vuex';
export default {
  name: 'message',
  data() {
    return {
      value: ''
    };
  },
  computed: {
    ...mapState('app', ['alertData']),
    ...mapState('editor', ['cvDetail']),
    maxlength() {
      let { basic_info: { lang } } = this.cvDetail
      return lang === 'cn' ? 15 : 49
    }
  },
  watch: {
    'alertData': {
      keep: true,
      immediate: true,
      handler: function (alertData) {
        if (!alertData.show) {
          document.body.style.position = 'initial'
          document.body.style.overflow = 'initial'
        }else{
          document.body.style.position = 'static'
          document.body.style.overflow = 'hidden'
        }
        if (alertData.inputData) {
          this.value = alertData.inputData.value || '';
        }
      }
    }
  },
  methods: {
    selectLabel(item) {
      this.value = item;
    },
    close() {
      this.$store.dispatch('app/setAlertDataShow', false);
    },
    cancel() {
      this.alertData.cancel && this.alertData.cancel(this.close);
      // this.close();
    },
    confirm() {
      this.alertData.confirm && this.alertData.confirm(this.close, this.value);
    },
    stopClick () {
    },
    inputChange(value) {
      if (!this.alertData.inputData || !this.alertData.inputData.length)
        return false;
      this.value = String(this.value).substr(0, +this.alertData.inputData.length);
    }
  }
}
</script>
<style lang="scss" scoped>
  .trash-alert-main {
    width: 0;
    height: 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    &.dark-theme-trash-alert{
      .box{
        background: #25272D;
        width: 500px;
        border-radius: 8px;
        .message-header{
          font-size: 16px;
          color: #fff;
          padding: 24px 24px 20px 24px;
          line-height: 22px;
        }
        .message-content{
          color: #fff;
          padding: 0 24px;
          line-height: 20px;
        }
        .message-btn{
          padding: 32px 24px 24px 24px;
          button{
            position: relative;
            height: 44px;
            padding: 0 10px;
            border-radius: 22px;
            // transition: all .15s;
            span{
              position: relative;
              z-index: 2;
              // transition: all .15s;
            }
          }
          .cancel{
            background: #51545A !important;
            color: #fff !important;
            border: 0 !important;
            &::before{
              position: absolute;
              display: block;
              content: '';
              left: 1px;
              right: 1px;
              top: 1px;
              bottom: 1px;
              border-radius: 22px;
              background: #25272D;
              z-index: 1;
            }
            span{
              color: #fff;
            }
            &:hover{
              background: linear-gradient(90deg, #FFBA52 0%, #F5563C 100%) !important;
              span{
                background: linear-gradient(90deg, #FFB952 1.79%, #F5573D 97.32%);
                -webkit-background-clip: text;
                color: transparent;
              }
            }
          }
          .action{
            border: 0 !important;
            background: linear-gradient(90deg, #FFBA52 0%, #F5563C 100%) !important;
            span{
              color: #000;
            }
            &:hover{
              background: linear-gradient(90deg, #FFCC80 0%, #F8816D 100%) !important;
            }
          }
        }
      }
    }
    .cover {
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, .5);
      position: fixed;
      top: 0;
      left: 0;
    }
    .box {
      width: 446px;
      height: fit-content;
      height: auto;
      background: #fff;
      border-radius: 4px;
      position: relative;
      z-index: 9;
      // position: fixed;
      // top: 0;
      // left: 0;
      // right: 0;
      // bottom: 0;
      // margin: auto;
      .message-close {
        font-size: 20px;
        color: #404040;
        font-weight: 600;
        float: right;
        cursor: pointer;
      }
      .message-header {
        height: fit-content;
        // border-bottom: 1px solid #E8E8E8;
        font-size: 18px;
        font-weight: 600;
        color: #404040;
        // line-height: 72px;
        padding: 32px 32px 18px 32px;
      }
      .message-content {
        // width: 360px;
        line-height: 24px;
        padding: 0 32px;
        font-size: 14px;
        color: #606060;
        .message-input-main {
          width: 100%;
          height: 40px;
          background: #F9F9F9;
          padding: 0;
          position: relative;
          input {
            width: calc(100% - 100px);
            height: 100%;
            border: none;
            background: transparent;
            padding: 0 18px;
            color: #404040;
          }
          .message-input-length {
            height: 100%;
            line-height: 40px;
            position: absolute;
            top: 0;
            right: 0;
            padding: 0 18px;
          }
        }
        .select-list{
          flex-wrap: wrap;
          //margin-top: 22px;
          .select-item{
            //width: 74px;
            margin-top: 22px;
            height: 20px;
            cursor: pointer;
            //margin-top: 14px;
            padding: 7px 18px;
            border-radius: 2px;
            border: 1px solid #ECECEC;
            color: #606060;
            line-height: 20px;
            text-align: center;
            margin-right: 16px;
            &:hover,&.is-active{
              border: 1px solid #ff4f4c;
              color: #ff4f4c;
            }
          }
        }
      }
      .message-btn {
        text-align: right;
        // position: absolute;
        // bottom: 25px;
        // right: 28px;
        padding: 25px 32px 26px 32px;
        display: flex;
        justify-content: flex-end;
        button {
          display: block;
          min-width: 80px;
          height: 36px;
          border: 1px solid #D9D9D9;
          border-radius: 2px;
          font-size: 14px;
          color: #606060;
          background: #fff;
          &.action {
            background: #FF6644;
            border-color: #FF6644;
            color: #fff;
          }
          &.cancel.seccess{
            border-color: #FF4F4C;
            color: #FF4F4C;
          }
          &:last-child {
            margin-left: 16px;
            padding-left: 10px;
            padding-right: 10px;
          }
        }
      }
    }
  }
</style>
